//
// Module for the External Login Approval wizard's Link To Existing User Step
//
rs.module("content/security/administration/externalloginapproval/linktoexistinguserstep",

    ["controls/components/event-banner"],

    function (eventBanner) {

        // Initialize the module
        function initialize(jsSelectors, backendUrls) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var searchTextInput = stepContainer.js(jsSelectors.searchTextInput);
            var domainUsersOnlyCheckBox = stepContainer.js(jsSelectors.domainUsersOnlyCheckBox);
            var loadingSpinner = stepContainer.js(jsSelectors.loadingSpinner);
            var applyButton = stepContainer.js(jsSelectors.applyButton);
            var existingUsersGridContainer = stepContainer.js(jsSelectors.existingUsersGridContainer);
            var existingUsersGridFilteredHidden = stepContainer.js(jsSelectors.existingUsersGridFilteredHidden);
            var skipCheckBox = stepContainer.js(jsSelectors.skipCheckBox);

            // On apply (i.e. Search) button click, display grid of retrieved existing users
            applyButton.on("click", function (event) {

                // prevent the button from causing a post
                event.preventDefault();

                // clear any messages in the message banner
                eventBanner.removeAllMessages();

                // validate form and if valid, display partial grid of existing users
                if (stepContainer.closest("form").valid()) {

                    loadingSpinner.show();

                    // if the user searches, clear the grid and uncheck the skip checkbox
                    clearExistingUsersGrid(true);
                    skipCheckBox.setChecked(false);

                    $.get(backendUrls.getExistingUsersGrid,
                        {
                            searchText: searchTextInput.val(),
                            domainUsersOnlyFlag: domainUsersOnlyCheckBox.is(':checked')
                        })
                        .showFieldErrors()
                        .done(function (html) {
                            existingUsersGridContainer.html(html);
                            existingUsersGridContainer.show();
                            existingUsersGridFilteredHidden.val(true);
                        })
                        .always(function () {
                            loadingSpinner.hide();
                        });
                }
            });

            // Handle skip checkbox changed event
            skipCheckBox.change(function () {
                // If checked, clear the searchtext field and grid results, with the next button enabled
                if (skipCheckBox.is(":checked")) {
                    clearExistingUsersGrid(false);
                    searchTextInput.val("");
                }
                // If unchecked, clear the grid results, with the next button disabled
                else {
                    clearExistingUsersGrid(true);
                }
            });

            // Clear the existing users grid
            function clearExistingUsersGrid(disableNextButton) {
                if (existingUsersGrid) {

                    existingUsersGrid.clearGridRows();

                    // Get the wizard's next button and disable it 
                    var wizardNextButton = $(`[data-wizard]`).js("_next");
                    wizardNextButton.setDisabled(disableNextButton);
                }
            }
        }
        
        // variable for accessing the existing users grid
        var existingUsersGrid;

        // Exported function used by module (_linktoexistinguserstepgrid.js) to set existingUsersGrid variable
        function setGrid(grid) {
            existingUsersGrid = grid;
        }

        // Exported public API
        var exports = {
            initialize: initialize,
            setGrid: setGrid
        };

        return exports;
    }
);